import { Controller } from "@hotwired/stimulus"

// Fait disparaître automatiquement les messages flash.
export default class extends Controller {
  static values = { delay: { type: Number, default: 4500 } }

  connect() {
    this.timeout = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timeout)
  }

  dismiss() {
    this.element.style.transition = "opacity 300ms ease"
    this.element.style.opacity = "0"
    setTimeout(() => {
      const container = this.element.parentElement
      this.element.remove()
      // Retire le conteneur (marge mt-4) s'il ne reste plus aucun message → évite la bande blanche résiduelle.
      if (container && container.children.length === 0) container.remove()
    }, 320)
  }
}
